import React from "react";
import Cookies from "js-cookie";

const Logout = () => {
  
    React.useEffect(() => {
        Cookies.remove("cognito-access-token");
        window.open(`/c/portal/logout`, '_self');  
    }, []);

    return (
       <div></div>
    );
};

export default Logout;
